import styled from '@emotion/styled';
import { ThemeContext } from '@shared/components/loading/ThemeContextLoader';
import { productResources } from '@shared/constants/product/ProductUtils';
import { AllLicenseTypes } from '@shared/models/organizations/AllLicenseTypes';
import { useContext } from 'react';
import { iconMap } from '../core/images/IconMap';
import SrOnlyText from '../core/text/SrOnlyText';

export interface ILicenseTypeLogoProps {
    licenseType: AllLicenseTypes;
    size?: number;
    color?: string;
}

export default function LicenseTypeLogo({ licenseType, size = 250, ...restProps }: ILicenseTypeLogoProps) {
    const { theme } = useContext(ThemeContext);
    const isLightMode = theme === 'light';
    const iconName = isLightMode ? productResources[licenseType].icon.light : productResources[licenseType].icon.dark;
    const svgToRender = iconMap[iconName] ?? null;

    return (
        <IconContainer $size={size} {...restProps}>
            {svgToRender}
            <SrOnlyText>{productResources[licenseType].title}</SrOnlyText>
        </IconContainer>
    );
}

const IconContainer = styled('span')<{ $size?: number; $color?: string }>`
    color: ${(props) => props.$color || 'inherit'};
    display: inline-block;
    line-height: 0;
    svg {
        width: ${(props) => props.$size + 'px' || '24px'};
        height: 100%;
    }
`;
